import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from 'src/routes/ProtectedRoute';
import PageNotFound from 'src/shared/components/page-not-found/PageNotFound';
import { getSurveyRoutesAvailability } from 'src/routes/state/routesSelector';
import { useAppSelector } from 'src/store';
import { IndividualRouteSetting, SurveyViews } from 'src/routes/routesConfig';
import { Resources } from 'src/shared/types';
import SurveyAdmin from './views/survey-admin/SurveyAdmin';
import NewSurveyDesign from './views/new-survey-design/NewSurveyDesign';
import SurveyDesignSummary from './views/survey-design-summary/SurveyDesignSummary';

export const surveyRouteSettings: { [key in SurveyViews]: IndividualRouteSetting } = {
    surveyAdmin: {
        name: 'Survey admin',
        path: '/survey-admin',
        handler: <SurveyAdmin />,
        resource: Resources.SURVEY_DESIGN,
    },
    newSurveyDesign: {
        name: 'New survey design',
        path: '/new-survey-design',
        handler: <NewSurveyDesign />,
        resource: Resources.NEW_SURVEY_DESIGN,
    },
    surveyDesignSummary: {
        name: 'Survey design summary',
        path: '/survey-design-summary',
        handler: <SurveyDesignSummary />,
        resource: Resources.SURVEY_DESIGN_SUMMARY,
    },
};

const Survey = () => {
    const routesConfig = useAppSelector(getSurveyRoutesAvailability);

    if (!routesConfig) {
        return null;
    }

    return (
        <Routes>
            {Object.keys(routesConfig).map(routeKey => {
                const isAvailable = routesConfig[routeKey as SurveyViews];
                const routeSetting = surveyRouteSettings[routeKey as SurveyViews];
                return (
                    <Route
                        path={routeSetting.path}
                        element={
                            <ProtectedRoute isAllowed={isAvailable} redirectPath={'/projects'} routeSetting={routeSetting}>
                                {routeSetting.handler}
                            </ProtectedRoute>
                        }
                        key={routeSetting.name}
                    />
                );
            })}
            <Route path='/*' element={<PageNotFound />} />
        </Routes>
    );
};
export default Survey;
